import { ProcedureToUpdate } from '@/modules/copay/entities/interfaces/usageStatements';

export const transformFormProceduresToPayload = (options: {
  updates: Record<string, Partial<ProcedureToUpdate>>;
  fieldsToPayload: (keyof ProcedureToUpdate)[];
}) => {
  return Object.values(options.updates).map((procedure) =>
    options.fieldsToPayload.reduce(
      (acc, field) => ({
        ...acc,
        [field]: procedure[field],
      }),
      {},
    ),
  );
};
